import { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { CamelCaseWithSpaces, CustomParseSafeHtml, GetBuildingGrade, LogInSchoolID, LogInUserID, formatDateToMMDDYYYY, getTypeWatchDelay, getUrlParameter, handleKeyPress, trackingHandle, shipStationUrlTrack, transformNameOfCol, typewatch } from '../../JS/Common';
import { ApiCmnHeadersGetCall, ApiCmnHeadersPostCall, ApiGetCall, ApiGetCDNData, ApiGetHeaders, ApiPostCall } from '../../JS/Connector';
import { saveAs } from 'file-saver'
import { CheckValidation } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import Pagination from 'react-js-pagination';
import CustomizationPopup from '../../Components/CustomizationPopup';
import UserDetailsPopup from '../../Components/UserDetailsPopup';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faStamp } from '@fortawesome/free-solid-svg-icons';
import { DeviceDetailsPopup } from '../../Components/DeviceDetailsPopup';
import TicketDetailsPopup from '../../Components/TicketDetailsPopup';
import SignatureCanvas from "react-signature-canvas";
import jinja from "jinja-js";
import html2pdf from "html2pdf.js";
import PageHead from '../../Components/PageHead';
import Tab from '../../Components/Tab';
import Popup from '../../Components/Popup';
import AlertPopup from '../../Components/AlertPopup';
import { ThemeContext } from '../../App';
import { log } from '../../JS/Logger';
import { useSelector } from 'react-redux';
import CustomFontAwesomeIcon from '../../Components/CustomFontAwesomeIcon';
import useConfig from '../../Hooks/useConfig';
import { useStickyAction } from '../../Hooks';

export function SchoolInvoice() {
    const { student, primary_text, parent_phone_number, adminCallNode, succes_text_color, error_text_color, inProgress_text_color } = useConfig();
    const { state } = useContext(ThemeContext);
    const StateData = useSelector((state) => state.authData);
    const [SchoolInvoiceData, setAllInvoiceData] = useState([]);
    const [CloseTicketData, setClosedTicketData] = useState([]);
    const [InvoiceModal, setInvoiceModal] = useState(false);
    const [checkno, setCheckno] = useState('');
    const [Alerts, setAlerts] = useState("");
    var shippingtype = state?.ShippingType;
    const [SearchStringVal, setSearchStringVal] = useState({
        SearchString: '',
        SortbyFlag: 'desc',
        SearchStringForCloseTicket: '',
        SortbyFlagForCloseTicket: 'desc'
    });
    const [BatchAndInvoiceId, setBatchAndInvoiceId] = useState({
        BatchId: '',
        InvoiceNum: '',
        BatchName: '',
        BatchType: '',
        ReceiveFlag: 1
    })
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [ChequeNoFlag, setChequeNoFlag] = useState('');
    const [GridTabs, setGridTabs] = useState({
        CloseTicketTab: "",
        BatchesTabs: "active",
        PastBatchesTabs: '',
        ResolvedTicketTab: ''
    });
    const showPagination = SchoolInvoiceData.length > 0;
    const navigate = useNavigate()
    const [currentPage1, setCurrentPage1] = useState(1);
    const [LimitForPagination1, setLimitForPagination1] = useState(25);
    const [pageRangeCount1, setpageRangeCount1] = useState(0);
    const showPagination1 = CloseTicketData.length > 0;
    var MoreDueFlag = getUrlParameter("flag");
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNamesForBilling, setColumnNamesForBilling] = useState([]);
    const [columnNamesForCloseTickets, setColumnNamesForCloseTickets] = useState([]);
    const [UserModal, setUserModal] = useState(false)
    const [Userid, setUserid] = useState('');
    const [ReponseForLink, setReponseForLink] = useState([]);
    const [ShowCreateBatchButton, setShowCreateBatchButton] = useState(false);
    const [ShowResolvedbtn, setShowResolvedbtn] = useState(false);
    const [ShowGenerateInvoicebtn, setShowGenerateInvoicebtn] = useState(false);
    const [ShowResolvedTicketsbtn, setShowResolvedTicketsbtn] = useState(false);
    const [ReceiveBatchModal, setReceiveBatchModal] = useState(false);
    const [ResolveTicketModal, setResolveTicketModal] = useState(false);
    const [PaymentModal, setPaymentModal] = useState(false);
    const [ResolvedModal, setResolvedModal] = useState(false);
    const [SelectedIdsForPending, setSelectedIdsForPending] = useState([]);
    const [SelectedIdsForResolved, setSelectedIdsForResolved] = useState([]);
    const [SelectedItemsForPending, setSelectedItemsForPending] = useState([]);
    const sigCanvasForReceivedBy = useRef({});
    const [SignatureDataForReceivedByGrid, setSignatureDataForReceivedByGrid] = useState('')
    const [isModal, setisModal] = useState({
        isshowpopup: false,
        isTicketDetailspopup: false,
    });
    const [TicketParams, setTicketParams] = useState({
        inventoryId: "",
        ticketId: "",
        Chargeabilityflag: ''
    });
    var SchoolId = LogInSchoolID;
    const location = useLocation();
    const FlagForCancel = location.state && location.state.cancelflag;
    const [SortKeyForBatches, setSortKeyForBatches] = useState(null)
    const [SortKeyForTickets, setSortKeyForTickets] = useState(null)
    const [lastChecked, setLastChecked] = useState(null);
    const [BuildingArray, setBuildingArray] = useState([]);
    const [LoanerDevices, setLoanerDevices] = useState([]);
    const [selectedBuilding, setselectedBuilding] = useState('');
    const [loanerChoices, setLoanerChoices] = useState({});
    const { tableWrapperRef, isOverflowing } = useStickyAction((GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active') ? setColumnNamesForCloseTickets : setColumnNamesForBilling);

    useEffect(() => {
        if (LoanerDevices.length > 0 && Object.keys(loanerChoices).length === 0) {
            const defaults = {};
            LoanerDevices.forEach(item => {
                defaults[item.device_id] = 1;
            });
            setLoanerChoices(defaults);
        }
    }, [LoanerDevices]);

    useEffect(() => {
        if (GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active') {
            ApiGetHeaders(16, setColumnNamesForCloseTickets)
        } else if (GridTabs.BatchesTabs == 'active' || GridTabs.PastBatchesTabs == 'active') {
            ApiGetHeaders(17, setColumnNamesForBilling)
        }
        GetBuildingGrade({ setBuildingArray });
    }, []);
    useEffect(() => {
        const selectedArray1 = [
            ...SelectedIdsForPending.map((id) => ({ id })),
        ];
        const idAndSubtotalArray1 = selectedArray1.map(({ id }) => ({ uuid: id }));
        setSelectedItemsForPending(idAndSubtotalArray1);
        if (idAndSubtotalArray1.length === 0) {
            setShowResolvedbtn(false)
            setShowGenerateInvoicebtn(false)
        }
    }, [SelectedIdsForPending])

    useEffect(() => {
        if (SelectedIdsForResolved.length === 0) {
            setShowResolvedTicketsbtn(false);
        }
    }, [SelectedIdsForResolved]);

    useEffect(() => {
        if (GridTabs.BatchesTabs == 'active') {
            GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, SortKeyForBatches ? SortKeyForBatches : null, 1, false);
        } else if (GridTabs.PastBatchesTabs == 'active') {
            GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, SortKeyForBatches ? SortKeyForBatches : null, 2, false);
        } else if (GridTabs.CloseTicketTab == 'active') {
            GetClosedTicketData(SearchStringVal.SearchStringForCloseTicket ? SearchStringVal.SearchStringForCloseTicket : null, SortKeyForTickets ? SortKeyForTickets : null, 1, selectedBuilding, false)
        } else {
            GetClosedTicketData(SearchStringVal.SearchStringForCloseTicket ? SearchStringVal.SearchStringForCloseTicket : null, SortKeyForTickets ? SortKeyForTickets : null, 2, selectedBuilding, false)
        }
        if (MoreDueFlag == 1) {
            if (GridTabs.BatchesTabs == 'active') {
                setGridTabs({ ...GridTabs, BatchesTabs: "active", CloseTicketTab: "", PastBatchesTabs: '', ResolvedTicketTab: '' });
                GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, null, 1, false);
            } else {
                setGridTabs({ ...GridTabs, BatchesTabs: "", CloseTicketTab: "", PastBatchesTabs: 'active', ResolvedTicketTab: '' });
                GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, null, 2, false);
            }
        }
        if (FlagForCancel == 1) {
            setGridTabs({ ...GridTabs, CloseTicketTab: "active", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: '' });
            GetClosedTicketData(null, null, 1, null, false);
            ApiGetHeaders(16, setColumnNamesForCloseTickets);
            setSearchStringVal({ ...SearchStringVal, SearchStringForCloseTicket: '', SearchString: '' });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [currentPage, LimitForPagination, currentPage1, LimitForPagination1, selectedBuilding]);

    async function GetSchoolInvoiceData(searchstring, sortkey, GridFlagForBilling, toogleSort) {
        if (!searchstring) searchstring = null;
        if (sortkey && toogleSort) SearchStringVal.SortbyFlag = SearchStringVal.SortbyFlag == "asc" ? "desc" : "asc";
        var joinedString = null;
        if (columnNamesForBilling.length > 0) {
            var joinedString = columnNamesForBilling.join('~');
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/billing/batches/all-data?userId=${LogInUserID}&schoolId=${LogInSchoolID}&search=${searchstring}&sortBy=${sortkey}&sortByOrder=${SearchStringVal.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&gridId=${GridFlagForBilling}&panelId=1&data=${joinedString}`).then((result) => {
                if (result === undefined || result === "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.total)
                    setAllInvoiceData(responseRs.tickets.length ? responseRs.tickets : [])
                    setLoading(false);
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }
    async function GetClosedTicketData(searchString, skey, flag, building, toogleSort) {
        if (!searchString) searchString = null;
        if (skey && toogleSort) SearchStringVal.SortbyFlagForCloseTicket = SearchStringVal.SortbyFlagForCloseTicket == "asc" ? "desc" : "asc";
        var GridFlag = null;
        if (flag == 1) {
            GridFlag = 16;
        } else {
            GridFlag = 39
        }
        setselectedBuilding(building)

        typewatch(async function () {
            setLoading(true)
            await ApiGetCall(`/schools/invoices/closed-tickets?schoolId=${LogInSchoolID}&search=${searchString}&sortBy=${skey}&sortByOrder=${SearchStringVal.SortbyFlagForCloseTicket}&gridId=${GridFlag}&page=${currentPage1}&limit=${LimitForPagination1}&filter=${building}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setpageRangeCount1(responseRs.msg.total)
                    setClosedTicketData(responseRs.msg.data.length ? responseRs.msg.data : [])
                    setLoading(false);
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }
    async function downloadReceipt(InvoiceNumber) {
        await ApiGetCall(`/schools/invoices/download-receipt?invoiceId=${InvoiceNumber}`).then((result) => {
            if (result == undefined || result == "") {
                setAlerts(<AlertsComp show={true} variant="success" msg={"No Receipt Found"} />);
                setTimeout(function () {
                    setAlerts(<AlertsComp show={false} />)
                }, 1500);
            } else {
                const responseRs = result;
                if (responseRs.length != 0) {
                    saveAs(responseRs, 'image.jpg');
                }
                setLoading(false);
            }
        });
    };
    async function ExtraDocument(id) {
        await ApiGetCall(`${adminCallNode}/batches/extra-docs?batchId=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = result;
                if (responseRs == "error") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"No extra attached document found"} />);
                    setTimeout(function () {
                        setAlerts(<AlertsComp show={false} />)
                    }, 3000);
                } else {
                    ApiGetCDNData("/" + responseRs, StateData?.Schoolnumber).then((blob) => {
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank');
                    });
                }
            }
        });
    };
    function getInvoiceDoc(doc) {
        ApiGetCDNData("/" + doc, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    }
    async function SubmitpaymentDetails() {
        var isFormValid = CheckValidation({ formID: 'batchNameRequired' });
        if (!isFormValid) return;
        setLoading(true);
        //Mark as Paid  ChequeNoFlag == 2
        //Mark as Paid with Cheque Number  ChequeNoFlag == 1
        // Pay online and Mark as Paid  ChequeNoFlag == 3
        var flagForOption = null
        if (ChequeNoFlag == 0 || ChequeNoFlag == 2) {
            flagForOption = 1
        } else if (ChequeNoFlag == 1) {
            flagForOption = 2
        } else {
            flagForOption = 1
        }
        var combineArray = [];
        var vjson = {};
        vjson['batchId'] = BatchAndInvoiceId.BatchId;
        vjson['invoiceId'] = BatchAndInvoiceId.InvoiceNum;
        vjson['chequeNo'] = checkno ? checkno : null;
        vjson['schoolId'] = LogInSchoolID;
        vjson['flag'] = flagForOption;
        vjson['UserID'] = LogInUserID;
        vjson['BatchReceiverSignature'] = null;
        vjson['AdminFlag'] = 2;
        combineArray.push(vjson);
        var raw = JSON.stringify({
            batches: combineArray
        });
        await ApiPostCall("/schools/invoices/payment-details", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setInvoiceModal(false);
                const responseRs = result;
                if (responseRs == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Payment Details Sent Successfully"} />);
                    setTimeout(function () {
                        setAlerts(<AlertsComp show={false} />)
                        var flag = GridTabs.BatchesTabs == 'active' ? 1 : 2;
                        GetSchoolInvoiceData(null, null, flag, false);
                    }, 1500);

                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        });
    }
    function renderContentForColumn(columnName, item) {
        const isActiveTab = GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active';

        const commonContentMap = {
            "created_at": isActiveTab ? (item.created_at ? formatDateToMMDDYYYY(item.created_at) : "-") : (formatDateToMMDDYYYY(item.created_at) || '-'),
            "Notes": <div className="note-wrap">{item.notes || '-'}</div>
        };

        const activeTabContentMap = {
            "ticket_num": (
                <span
                    className="cursor-pointer"
                    title="Show Ticket Details"
                    onClick={(e) => {
                        setisModal({ ...isModal, isTicketDetailspopup: true });
                        setTicketParams({ ...TicketParams, ticketId: item.id, inventoryId: item.inventory_id });
                    }}
                >
                    <u>{item.ticket_num || '-'}</u>
                </span>
            ),
            "Serial_number": (
                <span
                    className="cursor-pointer"
                    title="Show Device Details"
                    onClick={(e) => {
                        setisModal({ ...isModal, isshowpopup: true });
                        setTicketParams({ ...TicketParams, inventoryId: item.inventory_id, ticketId: item.id });
                    }}
                >
                    <u>{item?.inventory_management?.serial_number || "-"}</u>
                </span>
            ),
            "User": item?.inventory_management?.student_inventory?.student?.device_user_first_name ? (
                <u
                    className="cursor-pointer"
                    title="Show User Details"
                    onClick={(e) => {
                        setUserid(item?.inventory_management?.student_inventory?.student?.id);
                        setUserModal(true);
                    }}
                >
                    {item?.inventory_management?.student_inventory?.student?.device_user_first_name + ' ' + (item?.inventory_management?.student_inventory?.student?.device_user_middle_name || ' ') + ' ' + item?.inventory_management?.student_inventory?.student?.device_user_last_name}
                </u>
            ) : '-',
            "Parent_Guardian_Email": item?.inventory_management?.student_inventory?.student?.parent_guardian_email || '-',
            "Parent_phone_number": item?.inventory_management?.student_inventory?.student?.parent_phone_number || '-',
            "Parent_guardian_name": item?.inventory_management?.student_inventory?.student?.parent_guardian_name || '-',
            "Building": item?.inventory_management?.building_name?.name || '-',
            "Device_model": item?.inventory_management?.device_model || '-',
            "Grade": item?.inventory_management?.student_inventory?.student?.grade || '-',
            "Student_num": item?.inventory_management?.student_inventory?.student?.student_num || '-',
            "created_by": item?.user?.first_name + ' ' + item?.user?.last_name || "-",
            "return_location": item?.return_location?.name || '-'
        };

        const inactiveTabContentMap = {
            "Name": (
                <span
                    className="cursor-pointer"
                    title='Show Batch Details'
                    onClick={(e) => {
                        navigate('/ticket-history?id=' + item?.id, { state: { SchoolId, SchoolAdminFlag: 2 } })
                    }}
                >
                    <u>{item?.name || '-'}</u>
                </span>
            ),
            "InvoiceNum": item?.invoice_code == null ? <>-</> : <div>#{item?.invoice_code}</div>,
            "deviceCount": item.batch_log_count || '-',
            "Amount": item?.amount == null ? <>0</> : <div>${item?.amount}</div>,
            "Batch_Status": (
                <span>
                    {item?.type == 1 ?
                        <span >Pending Invoice</span>
                        : item?.type == 2 ?
                            <span >$0 Invoice</span>
                            : item?.type == 3 ?
                                <span >Finalized</span>
                                : item?.type == 4 ?
                                    <span >Invoice Sent</span>
                                    : item?.type == 5 ?
                                        <span >Invoice Received</span>
                                        :
                                        <span >Completed</span>
                    }
                </span>
            ),
            "Payment_Status": item?.payment_status == 1 ? (
                <span style={{ color: error_text_color }}>Pending</span>
            ) : item?.payment_status == 3 ? (
                <span style={{ color: succes_text_color }}>Success</span>
            ) :
                (
                    <span style={{ color: inProgress_text_color }}>In Progress</span>
                )
        };

        const contentMap = isActiveTab ? { ...commonContentMap, ...activeTabContentMap } : { ...commonContentMap, ...inactiveTabContentMap };

        return contentMap[columnName] || null;
    }
    const handleSortClick = (item) => {
        if (GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active') {
            if (item == "User") {
                item = "Device_user_first_name";
            } else if (item == 'created_by') {
                item = "first_name"
            }
        } else {
            if (item == 'deviceCount') {
                item = 'batch_log_count'
            }
        }
        if (item !== 0) {
            if (GridTabs.CloseTicketTab == 'active') {
                GetClosedTicketData(SearchStringVal.SearchStringForCloseTicket, item, 1, selectedBuilding, true)
                setSortKeyForTickets(item)
            } else if (GridTabs.BatchesTabs == 'active') {
                GetSchoolInvoiceData(SearchStringVal.SearchString, item, 1, true)
                setSortKeyForBatches(item)
            } else if (GridTabs.PastBatchesTabs == 'active') {
                GetSchoolInvoiceData(SearchStringVal.SearchString, item, 2, true)
                setSortKeyForBatches(item)
            } else if (GridTabs.ResolvedTicketTab == 'active') {
                GetClosedTicketData(SearchStringVal.SearchStringForCloseTicket, item, 2, selectedBuilding, true)
                setSortKeyForTickets(item)
            }
        }
    };
    async function handleReopenTicket() {
        var id = TicketParams.ticketId;
        setLoading(true);
        var raw = JSON.stringify({
            ticketId: id
        });
        await ApiPostCall("/schools/invoices/update-to-pending", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setResolveTicketModal(false);
                const responseRs = result;
                if (responseRs == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Ticket reopened successfully"} />);
                    setTimeout(function () {
                        setGridTabs({ ...GridTabs, CloseTicketTab: "active", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: '' });
                        GetClosedTicketData(null, null, 1, null, false)
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        })
    }
    async function PreviewInvoiceHandle(pdf, id) {
        if (pdf != null) {
            setLoading(true);
            var raw = JSON.stringify({
                invoiceId: id
            });
            await ApiPostCall("/schools/invoices/download-pdf", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = result;
                    if (responseRs == "success") {
                        ApiGetCDNData("/" + pdf, StateData?.Schoolnumber).then((blob) => {
                            const url = URL.createObjectURL(blob);
                            window.open(url, '_blank');
                        });
                        setGridTabs({ ...GridTabs, CloseTicketTab: "", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: 'active' });
                        GetClosedTicketData(null, null, 2, null, false)
                    } else {
                        setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                        setTimeout(() => {
                            setAlerts(<AlertsComp show={false} />)
                        }, 1500);
                    }
                }
            })
        } else {
            setAlerts(<AlertsComp show={true} variant="success" msg={"No Invoice Found"} />);
            setTimeout(function () {
                setAlerts(<AlertsComp show={false} />)
            }, 1500);
        }
    }
    async function handlePayment() {
        var id = TicketParams.ticketId;
        setLoading(true);
        var raw = JSON.stringify({
            ticketId: id,
            schoolId: SchoolId
        })

        await ApiPostCall("/schools/invoices/paid-resolved-ticket", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setPaymentModal(false);
                const responseRs = result;
                if (responseRs == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Ticket mark as paid successfully"} />);
                    setTimeout(function () {
                        setGridTabs({ ...GridTabs, CloseTicketTab: "", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: 'active' });
                        GetClosedTicketData(null, null, 2, null, false)
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        })

    }
    function handleHeaderCheckboxForPending(e, ticketFlag) {
        setShowResolvedbtn(true);
        setShowGenerateInvoicebtn(true);
        const isChecked = e.target.checked;
        if (ticketFlag === "allticket") {
            setSelectedIdsForPending(isChecked ? CloseTicketData.map(item => item.id) : []);
        }
    }
    function handleHeaderCheckboxForResolved(e, ticketFlag) {
        setShowResolvedTicketsbtn(true);
        const isChecked = e.target.checked;
        if (ticketFlag === "resolved") {
            setSelectedIdsForResolved(isChecked ? CloseTicketData?.filter(item => item?.invoice?.[0]?.invoice_pdf).map(item => item?.latest_invoice?.id) : []);
        }
    }
    function handleCheckboxForPending(e, ID) {
        const isChecked = e.target.checked;
        setShowResolvedbtn(true);
        setShowGenerateInvoicebtn(true);
        if (e.nativeEvent.shiftKey && lastChecked !== null) {
            const start = Math.min(lastChecked, ID);
            const end = Math.max(lastChecked, ID);

            setSelectedIdsForPending((prevIds) => {
                let newIds = [...prevIds];
                for (let i = start; i <= end; i++) {
                    if (isChecked && !newIds.includes(i)) {
                        newIds.push(i);
                    } else if (!isChecked && newIds.includes(i)) {
                        newIds = newIds.filter((id) => id !== i);
                    }
                }
                return newIds;
            });
        } else {
            setSelectedIdsForPending((prevIds) => {
                if (isChecked) {
                    return [...prevIds, ID];
                } else {
                    return prevIds.filter((id) => id !== ID);
                }
            });
        }
        setLastChecked(ID);
    }
    function handleCheckboxForResolved(e, ticketFlag, ID) {
        const isChecked = e.target.checked;
        setShowResolvedTicketsbtn(true);
        if (ticketFlag == "resolved") {
            setSelectedIdsForResolved((prevIds) => {
                if (isChecked) {
                    return [...prevIds, ID];
                } else {
                    return prevIds.filter((id) => id !== ID);
                }
            });
        }
    }
    async function ReceiveBatchCall() {
        var signatureBase64 = null;
        signatureBase64 = sigCanvasForReceivedBy.current.isEmpty() ? null : sigCanvasForReceivedBy.current.getTrimmedCanvas().toDataURL("image/png");
        const loanerPayload = LoanerDevices.map(device => ({
            deviceId: device.device_id,
            loanerId: device.loaner_device_id,
            loanerflag: loanerChoices[device.device_id] || 1,
            studentId: device.student_id || null,
        }));

        var raw = JSON.stringify({
            batchIds: [{ "uuid": BatchAndInvoiceId.BatchId }],
            flag: 2,
            userId: LogInUserID,
            batchReceiverSignature: signatureBase64,
            batchDeliveredSignature: null,
            loanerDevices: loanerPayload || []
        });
        setLoading(true)
        await ApiPostCall(`${adminCallNode}/billing/deliver-receive-btn`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setReceiveBatchModal(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Batch Received Successfully."} />);
                    setTimeout(() => {
                        GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, null, 1, false);

                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function ResolvedTicketCall() {
        var raw = JSON.stringify({
            ticketIds: SelectedItemsForPending,
            resolvedFlag: 1
        });
        setLoading(true)
        await ApiPostCall("/tickets/change-chargeability", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setResolvedModal(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Tickets has been successfully resolved"} />);
                    setTimeout(() => {
                        setGridTabs({ ...GridTabs, CloseTicketTab: "", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: 'active' });
                        GetClosedTicketData(null, null, 2, null, false)
                        setSelectedIdsForPending([]);
                        setSelectedIdsForResolved([]);
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const clearSignatureForReceivedBy = () => {
        if (SignatureDataForReceivedByGrid != null) {
            setSignatureDataForReceivedByGrid(null)
        } else {
            sigCanvasForReceivedBy?.current?.clear();
        }
    };
    function PrintPackingList(batchid) {
        setLoading(true)
        fetch(`${origin}/PackingListForAdminBatch.html`)
            .then(response => response.text())
            .then(templateText => jinja.compile(templateText))
            .then(template => {
                ApiCmnHeadersGetCall("/schools/billing-batches/print-list?batchId=" + batchid)
                    .then(response => JSON.parse(response))
                    .then(data => {
                        const formattedDate = new Date(data.createdAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        });
                        const rendered = template.render({ data, formattedDate });
                        const pdfContent = CustomParseSafeHtml(rendered, false);
                        pdfContent.style.padding = '20px';
                        html2pdf().from(pdfContent).save();
                        setLoading(false)
                    })
                    .catch(error => {
                        setLoading(false)
                        log.error('Error loading data from API', error);
                    });
            })
            .catch(error => {
                setLoading(false)
                log.error('Error loading template', error);
            });
    }
    async function downloadResolvedInvoice() {
        setLoading(true);
        var vArray = [];
        SelectedIdsForResolved.map((id) =>
            vArray.push(id)
        )
        var FinalArray = vArray.map(item => String(item));
        const formdata = new FormData();
        formdata.append('schoolId', SchoolId);
        formdata.append('uuid', JSON.stringify(FinalArray));
        formdata.append('flag', 1);

        ApiCmnHeadersPostCall(`/schools/invoices/create-multiple`, formdata)
            .then(result => {
                const responseRs = JSON.parse(result);
                if (responseRs.response == "success") {
                    ApiGetCDNData("/" + responseRs.path, StateData?.Schoolnumber).then((blob) => {
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank');
                    });
                    setTimeout(() => {
                        setSelectedIdsForResolved([]);
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={"Failed to download invoice."} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
                setLoading(false);
            })
            .catch(error => log.error('error', error));
    }
    function handleSearchChange(e) {
        const searchValue = e.target.value || null;
        setCurrentPage(1);

        if (GridTabs.CloseTicketTab == 'active') {
            GetClosedTicketData(searchValue, null, 1, selectedBuilding, false);
        } else if (GridTabs.BatchesTabs == 'active') {
            GetSchoolInvoiceData(searchValue, null, 1, false);
        } else if (GridTabs.PastBatchesTabs == 'active') {
            GetSchoolInvoiceData(searchValue, null, 2, false);
        } else {
            GetClosedTicketData(searchValue, null, 2, selectedBuilding, false);
        }

        const searchStringKey = (GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active') ? 'SearchStringForCloseTicket' : 'SearchString';
        setSearchStringVal({ ...SearchStringVal, [searchStringKey]: searchValue });
    }
    function handleTabClick(tabType) {
        setCurrentPage(1);
        setCurrentPage1(1);
        if (tabType == "currentbatch") {
            setGridTabs({ ...GridTabs, CloseTicketTab: "", BatchesTabs: "active", PastBatchesTabs: '', ResolvedTicketTab: '' });
            GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, null, 1, false);
            if (columnNamesForBilling.length == 0) {
                ApiGetHeaders(17, setColumnNamesForBilling)
            }
            ApiGetHeaders(17, setColumnNamesForBilling)
            setSearchStringVal({ ...SearchStringVal, SearchStringForCloseTicket: '', SearchString: '' })
            setSelectedIdsForPending([])
            setSelectedIdsForResolved([])
        } else if (tabType == "pastbatch") {
            setGridTabs({ ...GridTabs, CloseTicketTab: "", BatchesTabs: "", PastBatchesTabs: 'active', ResolvedTicketTab: '' });
            GetSchoolInvoiceData(SearchStringVal.SearchString ? SearchStringVal.SearchString : null, null, 2, false);
            if (columnNamesForBilling.length == 0) {
                ApiGetHeaders(17, setColumnNamesForBilling)
            }
            setSearchStringVal({ ...SearchStringVal, SearchStringForCloseTicket: '', SearchString: '' })
            setShowCreateBatchButton(false)
            setSelectedIdsForPending([])
            setSelectedIdsForResolved([])
        } else if (tabType == "ticketinvoice") {
            setGridTabs({ ...GridTabs, CloseTicketTab: "active", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: '' });
            GetClosedTicketData(null, null, 1, null, false)
            if (columnNamesForCloseTickets.length == 0) {
                ApiGetHeaders(16, setColumnNamesForCloseTickets)
            }
            setSearchStringVal({ ...SearchStringVal, SearchStringForCloseTicket: '', SearchString: '' })
            setShowCreateBatchButton(false)
            setSelectedIdsForPending([])
            setSelectedIdsForResolved([])
        } else if (tabType == "resolved") {
            setGridTabs({ ...GridTabs, CloseTicketTab: "", BatchesTabs: "", PastBatchesTabs: '', ResolvedTicketTab: 'active' });
            GetClosedTicketData(null, null, 2, null, false)
            if (columnNamesForCloseTickets.length == 0) {
                ApiGetHeaders(16, setColumnNamesForCloseTickets)
            }
            setSearchStringVal({ ...SearchStringVal, SearchStringForCloseTicket: '', SearchString: '' })
            setShowCreateBatchButton(false)
            setSelectedIdsForPending([])
            setSelectedIdsForResolved([])
        }
    }
    const ReceiveModalBody = (
        <div className="parent" id="batchNameRequired">
            <div className='col-12 text-justify px-1'>Marking a batch as paid from any of the options below will mean that you have paid {primary_text} invoice generated for this batch and all the tickets under this batch will be marked as Closed.</div>
            <div className="col-md-12 align-item-center justify-content-between py-3">
                <div className="form-check pt-2">
                    <input className="form-check-input" checked={ChequeNoFlag == 2} type="radio" name='ParentalCoverage' value='0' id="No" onChange={(e) => setChequeNoFlag(2)} />
                    <label className="form-check-label">
                        Mark as Paid
                    </label>
                </div>
                <div className="form-check pt-2">
                    <input className="form-check-input" checked={ChequeNoFlag == 1} type="radio" name='ParentalCoverage' value='1' id="Yes" onChange={(e) => setChequeNoFlag(1)} />
                    <label className="form-check-label">
                        Mark as Paid with Cheque Number
                    </label>
                </div>
                <div className="form-check pt-2">
                    <input className="form-check-input" checked={ChequeNoFlag == 3} type="radio" name='ParentalCoverage' value='1' id="Yes" onChange={(e) => setChequeNoFlag(3)} />
                    <label className="form-check-label">
                        Pay online and Mark as Paid
                    </label>
                </div>

            </div>
            {ChequeNoFlag == 1 && (
                <div className=' col-12  mt-2 px-1'>
                    <input type="text" autoComplete='off' name='partName' className="form-control partNamee" required value={checkno}
                        placeholder='Enter Your Cheque Number *' onChange={(e) => setCheckno(e.target.value)} onKeyPress={handleKeyPress} />
                    <span className="form-text invalid-feedback" >
                        *required
                    </span>
                </div>
            )}
            {ChequeNoFlag == 3 && (
                <div>
                    <div className='ps-4'>
                        {ReponseForLink ?
                            <>
                                <a href={ReponseForLink} onClick={(e) => { e.preventDefault(); window.open(ReponseForLink, '_blank'); }}>
                                    {ReponseForLink}
                                </a>
                                <div className='pt-2'>Above is the invoice link for this batch, please click on link to Pay online in a new tab. After successful payment, you can click Send Notification button below.</div>
                            </>
                            :
                            <div>No Link Found</div>
                        }
                    </div>

                </div>
            )}

        </div>
    )
    const ReceiveBatchModalBody = (
        <div className='row'>
            {LoanerDevices.length > 0 &&
                <>
                    <b className='font-14'>Resolve Loaner Device Assignments</b>
                    <div>
                        The following users have a loaner device currently assigned. Please choose whether to return the loaner and keep the original device, or assign the loaner permanently to the user.
                    </div>
                    <div>
                        <div className='col-12 greyBox mt-3 data-table-container'>
                            <div className='row font-14 GridHeader'>
                                <div className='col-md-4 text-center'>{student}</div>
                                <div className='col-md-4 text-center'>Original Device</div>
                                <div className='col-md-4 text-center'>Loaner Device</div>
                            </div>
                            <hr className='my-2' />
                            <div className='row px-2'>
                                {LoanerDevices.length > 0 &&
                                    LoanerDevices.map((item, index) => {
                                        return <div className='col-md-12 mb-2 font-13' key={index}>
                                            <div className='row py-1' style={{ background: "white" }}>
                                                <div className='col-md-4 text-center'>{item.student_num || '-'}</div>
                                                <div className='col-md-4 text-center'>{item.serial_num || '-'}</div>
                                                <div className='col-md-4 text-center'>{item.loaner_serial_num || '-'}</div>
                                            </div>
                                            <div className='row py-2' style={{ background: "white" }}>
                                                <div className="col-md-6 FormLabel">
                                                    <input
                                                        className="form-check-input me-2"
                                                        type="radio"
                                                        name={`loanerChoice_${item.device_id}`}
                                                        checked={loanerChoices[item.device_id] === 1}
                                                        onChange={() => setLoanerChoices(prev => ({ ...prev, [item.device_id]: 1 }))}
                                                    />
                                                    Keep original device
                                                </div>
                                                <div className="col-md-6 FormLabel">
                                                    <input
                                                        className="form-check-input me-2"
                                                        type="radio"
                                                        name={`loanerChoice_${item.device_id}`}
                                                        checked={loanerChoices[item.device_id] === 2}
                                                        onChange={() => setLoanerChoices(prev => ({ ...prev, [item.device_id]: 2 }))}
                                                    />
                                                    Assign loaner permanently
                                                </div>
                                            </div>

                                        </div>
                                    })
                                }
                            </div>

                        </div>
                    </div>
                </>
            }
            <h6 className='mt-3'>
                By confirming 'Yes,' the original devices will be returned to the users, and all the tickets under this batch will be marked as Closed. Are you sure you want to proceed?
            </h6>
            <div className="greyBox mt-4">
                <div className='fw-600 font-15 text-center'>Received By Signature:</div>
                <div className='mt-2 text-center'>
                    {SignatureDataForReceivedByGrid ? (
                        <img src={SignatureDataForReceivedByGrid} alt="Received By Signature" />
                    ) : (
                        <SignatureCanvas
                            ref={sigCanvasForReceivedBy}
                            canvasProps={{ width: 430, height: 100, className: "signatureCanvas" }}
                        />
                    )}
                </div>
                <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForReceivedBy}><u>Clear</u></label></div>
            </div>
        </div>
    )

    function handleGenerateInvoice() {
        navigate('/CloseTicketInvoice', { state: { tickets: SelectedItemsForPending } })
    }
    async function getAllLoanerDevices(item) {
        await ApiGetCall(`${adminCallNode}/billing/batches/loaner-devices?batchId=${item.id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    setLoanerDevices(responseRs);
                }
                setReceiveBatchModal(true);
                setSignatureDataForReceivedByGrid(item?.batch_receiver_signature || null);
                setBatchAndInvoiceId({ ...BatchAndInvoiceId, BatchId: item.id, ReceiveFlag: 2 })
            }
        });
    }

    async function ExtraDocument1(FedExQr) {
        ApiGetCDNData("/" + FedExQr, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "ShipStation_Label";
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        });
    };
    return (
        <Fragment>
            <PageHead LimitForPagination={GridTabs.BatchesTabs == 'active' || GridTabs.PastBatchesTabs == 'active' ? LimitForPagination : LimitForPagination1}
                setLimitForPagination={GridTabs.BatchesTabs == 'active' || GridTabs.PastBatchesTabs == 'active' ? setLimitForPagination : setLimitForPagination1}
                setCurrentPage={GridTabs.BatchesTabs == 'active' || GridTabs.PastBatchesTabs == 'active' ? setCurrentPage : setCurrentPage1} heading={"Billing"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <section>
                <div className="GridBox mt-2 p-3">
                    <div className="row align-items-center mb-3">
                        <div className="col-12 px-0">
                            <ul className="nav nav-tabs px-3">
                                <Tab isActive={GridTabs.BatchesTabs == 'active'}
                                    label="Pending Batches" onClick={() => handleTabClick('currentbatch')} col={'col-md-2'} />
                                <Tab isActive={GridTabs.PastBatchesTabs == 'active'}
                                    label="Resolved Batches" onClick={() => handleTabClick('pastbatch')} col={'col-md-2'} />
                                <Tab isActive={GridTabs.CloseTicketTab == 'active'}
                                    label="Ticket Invoicing" onClick={() => handleTabClick('ticketinvoice')} col={'col-md-2'} />
                                <Tab isActive={GridTabs.ResolvedTicketTab == 'active'}
                                    label="Resolved Tickets" onClick={() => handleTabClick('resolved')} col={'col-md-2'} />
                            </ul>
                        </div>
                        <div className='col-md-12 d-flex align-items-center'>
                            <div className='col-md-7 redText font-11 pt-3'>
                                {GridTabs.BatchesTabs == 'active' && (
                                    <div className='ps-2'>
                                        <label>* The payment is currently being processed.</label><br />
                                    </div>
                                )}
                                {GridTabs.CloseTicketTab == 'active' && (
                                    <div className='theme-colorcode ps-2'>
                                        <label>*Billable Tickets</label>
                                    </div>
                                )}
                                {GridTabs.ResolvedTicketTab == 'active' && (
                                    <>
                                        <FontAwesomeIcon icon={faStamp} style={{ height: '20px', color: 'var(--unpaid_color)' }} className='ps-2' />
                                        <label className='ps-2' style={{ color: 'var(--unpaid_color)' }}>Unpaid</label>
                                        <FontAwesomeIcon icon={faStamp} style={{ height: '20px', color: 'var(--paid_color)' }} className='ps-3' />
                                        <label className='theme-colorcode ps-2'>Paid</label>
                                    </>
                                )}
                            </div>
                            {GridTabs.CloseTicketTab == 'active' && (
                                <div className="col-md-5 text-end pt-2 px-0 mx-0">
                                    <div className="col-6 offset-md-6 py-1 pe-0">
                                        <select className="FilterBorder"
                                            onChange={(e) => {
                                                setCurrentPage(1);
                                                setCurrentPage1(1);
                                                setselectedBuilding(e.target.value == 0 ? null : e.target.value)
                                            }}>
                                            <option value="0">Filter by Building</option>
                                            {BuildingArray.map((item, j) => (
                                                <option value={item.id} key={j}>
                                                    {item.building}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {ShowGenerateInvoicebtn == true && (
                                        <label className="BorderBtn text-end  mt-0" onClick={() => handleGenerateInvoice()}>Generate Invoice </label>
                                    )}
                                    {ShowResolvedbtn == true && (
                                        <label className="BorderBtn text-end  mt-0" onClick={() => setResolvedModal(true)}>Resolved </label>
                                    )}

                                </div>
                            )}
                            {GridTabs.ResolvedTicketTab == 'active' && (
                                <div className="col-md-5 text-end px-0 mx-0 pt-2">
                                    <div className="col-6 offset-md-6 py-1 pe-0">
                                        <select className="FilterBorder"
                                            onChange={(e) => {
                                                setCurrentPage(1);
                                                setCurrentPage1(1);
                                                setselectedBuilding(e.target.value == 0 ? null : e.target.value)
                                            }}>
                                            <option value="0">Filter by Building</option>
                                            {BuildingArray.map((item, j) => (
                                                <option value={item.id} key={j}>
                                                    {item.building}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {ShowResolvedTicketsbtn == true && (
                                        <label className="BorderBtn  text-center me-0 mt-0" onClick={downloadResolvedInvoice}>Download All Invoices </label>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="greyBox p-3">
                        {GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active' ?
                            <>
                                <div className="data-table-container" ref={tableWrapperRef}>
                                    <table className="table data-table">
                                        <thead className='GridHeader'>
                                            <tr>
                                                {GridTabs.CloseTicketTab == 'active' && CloseTicketData?.length != 0 && (
                                                    <th scope="col"> <input className='form-check-input' type="checkbox" checked={SelectedIdsForPending.length == CloseTicketData.length} onChange={(e) => handleHeaderCheckboxForPending(e, "allticket")} /></th>
                                                )}

                                                {GridTabs.ResolvedTicketTab == 'active' &&
                                                    <th scope="col">
                                                        {CloseTicketData?.filter(item => item?.invoice?.[0]?.invoice_pdf)?.length != 0 && (
                                                            <input className='form-check-input' type="checkbox" checked={SelectedIdsForResolved.length != 0 && SelectedIdsForResolved.length == CloseTicketData?.filter(item => item?.invoice?.[0]?.invoice_pdf)?.length} onChange={(e) => handleHeaderCheckboxForResolved(e, "resolved")} />
                                                        )}
                                                    </th>
                                                }

                                                {columnNamesForCloseTickets?.map((item) => {
                                                    const columnName = item.replace(/_/g, ' ');
                                                    const transformedName = transformNameOfCol(columnName);
                                                    if (!transformedName) return null;
                                                    return columnName != parent_phone_number && columnName != 'created by' ?
                                                        <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                            {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                                            <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                        </th>
                                                        :
                                                        <th key={item} scope="col" className='fw-600'>
                                                            {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(columnName)}
                                                        </th>
                                                })}
                                                <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                    Action
                                                    <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5"
                                                        title='Customize Headers' style={{ height: '25px' }}
                                                        onClick={(e) => setCustomizationModal(true)} />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {CloseTicketData?.length != 0 ? (
                                                CloseTicketData?.map((item, i) => {
                                                    return (
                                                        <tr key={i} className={`OddEvenClass tableBorderHide ${GridTabs.CloseTicketTab == 'active' && (item.chargeability == 1 ? 'theme-color-batch' : '')}  ${item.InvoiceSent == 1 ? 'grayColor' : ''}`}>
                                                            {GridTabs.CloseTicketTab == 'active' && (
                                                                <td className="py-12">
                                                                    <input
                                                                        className='form-check-input'
                                                                        type="checkbox"
                                                                        checked={SelectedIdsForPending.includes(item.id)}
                                                                        onChange={(e) => handleCheckboxForPending(e, item.id)}
                                                                    />
                                                                </td>
                                                            )}


                                                            {GridTabs.ResolvedTicketTab == 'active' && (
                                                                <td className="py-12">
                                                                    {item?.invoice?.[0]?.invoice_pdf && (
                                                                        <input
                                                                            className='form-check-input'
                                                                            type="checkbox"
                                                                            checked={SelectedIdsForResolved.includes(item?.latest_invoice?.id)}
                                                                            onChange={(e) => handleCheckboxForResolved(e, "resolved", item?.latest_invoice?.id)}
                                                                        />
                                                                    )}
                                                                </td>
                                                            )}

                                                            {columnNamesForCloseTickets?.map(header => (
                                                                <td className="py-12" key={header}>
                                                                    {renderContentForColumn(header, item)}
                                                                </td>
                                                            ))}
                                                            <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                                {GridTabs.CloseTicketTab == 'active' ? (
                                                                    <img
                                                                        src="/images/InvoiceBlackIcon.svg"
                                                                        className="px-1 cursor-pointer"
                                                                        title="Generate Invoice"
                                                                        onClick={(e) => { navigate('/CloseTicketInvoice', { state: { Ticketid: item.id } }); }}
                                                                    />
                                                                ) : null}

                                                                {GridTabs.ResolvedTicketTab === 'active' && (
                                                                    <div className='row'>
                                                                        <div className='col-3 text-center'>
                                                                            {item?.invoice.length == 0 ?
                                                                                <img
                                                                                    src="/images/TransactionIcon.svg"
                                                                                    className="px-1 cursor-pointer"
                                                                                    title="Reopen Ticket"
                                                                                    onClick={() => {
                                                                                        setResolveTicketModal(true);
                                                                                        setTicketParams({ ...TicketParams, ticketId: item.id });
                                                                                    }}
                                                                                    height="22px"
                                                                                />
                                                                                :
                                                                                <>-</>
                                                                            }
                                                                        </div>
                                                                        <div className='col-3 text-center'>
                                                                            {item?.invoice?.[0]?.invoice_pdf ?
                                                                                <img
                                                                                    src="/images/previewpdficon.svg"
                                                                                    className="px-1 cursor-pointer"
                                                                                    title="Preview Invoice"
                                                                                    onClick={() => PreviewInvoiceHandle(item?.latest_invoice?.invoice_pdf, item?.latest_invoice?.id)}
                                                                                    style={{ height: '22px' }}
                                                                                />
                                                                                :
                                                                                <>-</>
                                                                            }
                                                                        </div>
                                                                        <div className='col-3 text-center'>
                                                                            {item?.invoice?.length > 0 ? (
                                                                                <>
                                                                                    {item?.invoice?.[0]?.paid_status == 1 ? (
                                                                                        <CustomFontAwesomeIcon icon={faStamp} title="Paid" className='' style={{ height: '20px', color: 'var(--paid_color)' }} />
                                                                                    ) : (
                                                                                        <CustomFontAwesomeIcon icon={faStamp} title="Mark as paid" className='cursor-pointer' style={{ height: '20px', color: 'var(--unpaid_color)' }} onClick={() => {
                                                                                            setPaymentModal(true);
                                                                                            setTicketParams({ ...TicketParams, ticketId: item.id });
                                                                                        }} />
                                                                                    )}
                                                                                </>
                                                                            ) : <></>}

                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                }))
                                                :
                                                <tr><td colSpan={15} className="p-3 text-center"> No Record Found </td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {showPagination1 && (
                                    <Pagination activePage={currentPage1} totalItemsCount={pageRangeCount1}
                                        pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination1} onChange={(e) => setCurrentPage1(e)}
                                        color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                                        itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                                )}
                            </>
                            :
                            <></>
                        }

                        {GridTabs.BatchesTabs == 'active' || GridTabs.PastBatchesTabs == 'active' ?
                            <>
                                <div className="data-table-container" ref={tableWrapperRef}>
                                    <table className="table data-table">
                                        <thead className='GridHeader'>
                                            <tr>
                                                {columnNamesForBilling?.map((item) => {
                                                    const columnName = item.replace(/_/g, ' ');
                                                    const transformedName = transformNameOfCol(columnName);
                                                    if (!transformedName) return null;
                                                    return (
                                                        item != "Payment_Status" && item != "Batch_Status" ?
                                                            <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                                {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                                                <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                            </th>
                                                            :
                                                            <th key={item} scope="col" className='fw-600'>
                                                                {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                                            </th>
                                                    );
                                                })}
                                                {shippingtype == 2 &&
                                                    <th scope='col' className='fw-600'>Tracking Num</th>
                                                }
                                                {GridTabs.BatchesTabs == 'active' &&
                                                    <>
                                                        <th scope='col' className='fw-600'>Receive</th>

                                                        <th scope='col' className='fw-600'>Mark as Paid</th>
                                                    </>
                                                }
                                                <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                    Action
                                                    <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5"
                                                        title='Customize Headers' style={{ height: '25px' }}
                                                        onClick={(e) => setCustomizationModal(true)} />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {SchoolInvoiceData?.length != 0 ? (
                                                SchoolInvoiceData?.map((item, i) => {
                                                    return (
                                                        <tr key={i} className={`${item.type == 4 && GridTabs.BatchesTabs == 'active' ? 'redText' : ''} OddEvenClass tableBorderHide`}>
                                                            {columnNamesForBilling?.map(header => (
                                                                <td className="py-12" key={header}> {renderContentForColumn(header, item)} </td>
                                                            ))}
                                                            {shippingtype == 2 &&
                                                                <td className="py-12">
                                                                    {item?.tracking_num != null ? <u className='cursor-pointer' onClick={(e) => shipStationUrlTrack(item?.tracking_url)}>{item?.tracking_num}</u> : <>-</>}
                                                                </td>
                                                            }
                                                            {GridTabs.BatchesTabs == 'active' &&
                                                                <td className='text-center ps-0'>
                                                                    {item.type == 3 || item.type == 4 ?

                                                                        <img
                                                                            src="/images/TransactionIcon.svg"
                                                                            className="cursor-pointer"
                                                                            title="Receive Batch"
                                                                            onClick={(e) => {
                                                                                getAllLoanerDevices(item);

                                                                            }}
                                                                            height="22px"
                                                                        />
                                                                        :
                                                                        <span style={{ color: "black" }}>-</span>
                                                                    }
                                                                </td>
                                                            }
                                                            {GridTabs.BatchesTabs == 'active' &&
                                                                <td className='py-12 text-center'>
                                                                    {item.type == 4 || item.type == 5 ?
                                                                        item.cheque_no == null ?
                                                                            <CustomFontAwesomeIcon
                                                                                icon={faDollarSign}
                                                                                className="pe-2 cursor-pointer"
                                                                                title='Mark as Paid'
                                                                                onClick={(e) => {
                                                                                    setReponseForLink(item?.payment_link)
                                                                                    setBatchAndInvoiceId({ ...BatchAndInvoiceId, BatchId: item.id, InvoiceNum: item?.invoice_id, BatchName: item.name, BatchType: item.type });
                                                                                    setInvoiceModal(true);
                                                                                    setCheckno("");
                                                                                    setChequeNoFlag(item?.payment_link ? 3 : 2)
                                                                                }}
                                                                            />
                                                                            :
                                                                            <span className="px-2 cursor-pointer" style={{ color: "black" }}>{item.cheque_no}</span>
                                                                        :
                                                                        <>-</>
                                                                    }
                                                                </td>
                                                            }
                                                            <td className={`py-2 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                                {GridTabs.PastBatchesTabs == 'active' &&
                                                                    <img
                                                                        src="/images/DownloadReceipt.svg"
                                                                        className="px-2 cursor-pointer"
                                                                        title="Download Receipt"
                                                                        onClick={() => downloadReceipt(item?.invoice_id)}
                                                                        height="22px"
                                                                    />
                                                                }
                                                                <img src="/images/extraDocumenticon.svg" className="cursor-pointer" title="Preview Attached Document" onClick={(e) => ExtraDocument(item.id)} style={{ width: '15px' }} />
                                                                <img src="/images/printlabelicon.svg" title="Show Packing List" className="img-fluid cursor-pointer px-2" onClick={(e) => PrintPackingList(item.id)} style={{ height: 18 }} />
                                                                {item?.invoice_pdf != null && (<img src="/images/previewpdficon.svg" className="cursor-pointer" title="Preview Invoice" style={{ height: 18 }} onClick={(e) => getInvoiceDoc(item?.invoice_pdf)} />)}
                                                                {shippingtype == 2 && item?.shipstation_label ? (
                                                                    <img src="/images/eye.png" className="cursor-pointer pe-1" title="Preview Shipping Label" style={{ height: "15px" }}
                                                                        onClick={(e) => ExtraDocument1(item?.shipstation_label)} />
                                                                ) : shippingtype == 2 && item?.label_url ? (
                                                                    <img src="/images/eye.png" className="cursor-pointer pe-1" title="Preview Shipping Label" style={{ height: "15px" }}
                                                                        onClick={(e) => shipStationUrlTrack(item?.label_url)} />)
                                                                    : <></>}
                                                            </td>
                                                        </tr>
                                                    )
                                                }))
                                                :
                                                <tr><td colSpan={15} className="p-3 text-center"> No Record Found </td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {showPagination && (
                                    <Pagination
                                        activePage={currentPage}
                                        totalItemsCount={pageRangeCount}
                                        pageRangeDisplayed={15}
                                        itemsCountPerPage={LimitForPagination}
                                        onChange={(e) => setCurrentPage(e)}
                                        color="primary"
                                        lastPageText=""
                                        firstPageText=""
                                        itemClassFirst="MasterClass"
                                        itemClassPrev="MasterClass"
                                        itemClassNext="MasterClass"
                                        itemClassLast="MasterClass"
                                        hideFirstLastPages={true}
                                    />
                                )}
                            </>
                            :
                            <></>
                        }
                    </div>
                </div>
            </section>
            <Popup isshow={InvoiceModal} size={"md"} title={"Mark as Paid"}
                closePopup={(e) => { setInvoiceModal(false); setChequeNoFlag(0) }}
                modalBody={ReceiveModalBody} handleSave={SubmitpaymentDetails} visibleSaveBtn={true} btnText={"Save"} />


            <AlertPopup isshow={ResolveTicketModal} img={'/images/greenInfo.svg'}
                headingtext={'Are you sure?'} text={`You want to reopen this ticket? This ticket will be shown in Ticket Invoicing.`}
                cancelcall={(e) => setResolveTicketModal(false)}
                canceltext={"No"} successtext={"Yes, Reopen it"} successcall={handleReopenTicket} btntype={'SaveBtn'} />
            <AlertPopup isshow={PaymentModal} img={'/images/greenInfo.svg'}
                headingtext={'Are you sure?'} text={`Would you like to mark this ticket as paid?`}
                cancelcall={(e) => setPaymentModal(false)}
                canceltext={"No"} successtext={"Yes, Mark it as paid!"} successcall={handlePayment} btntype={'SaveBtn'} />

            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Billing'} tabFlag={GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab ? '16' : '17'} GetCall={() => { GridTabs.CloseTicketTab == 'active' || GridTabs.ResolvedTicketTab == 'active' ? ApiGetHeaders(16, setColumnNamesForCloseTickets) : ApiGetHeaders(17, setColumnNamesForBilling) }} />}
            {UserModal && <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={Userid} />}
            {isModal.isshowpopup && <DeviceDetailsPopup Showbuttons={1} ticketid={TicketParams.ticketId} createticketbutton={true} deviceid={TicketParams.inventoryId} activetab="device" isShow={isModal.isshowpopup} ClosePopup={(e) => setisModal({ ...isModal, isshowpopup: false })} />}
            {isModal.isTicketDetailspopup && <TicketDetailsPopup isShow={isModal.isTicketDetailspopup} ticketid={TicketParams.ticketId} inventoryid={TicketParams.inventoryId} ClosePopup={(e) => setisModal({ ...isModal, isTicketDetailspopup: false })} />}

            <Popup isshow={ReceiveBatchModal} size={"md"} title={"Receive Batch"}
                closePopup={(e) => { setReceiveBatchModal(false); setLoanerChoices({}); setLoanerDevices([]); }}
                modalBody={ReceiveBatchModalBody} handleSave={ReceiveBatchCall} visibleSaveBtn={true} btnText={"Yes"} />



            <AlertPopup isshow={ResolvedModal} img={'/images/greenInfo.svg'}
                headingtext={`If you select 'Yes,' all tickets will be marked as Resolved. Are you sure you want to proceed?`} text={''}
                cancelcall={(e) => { setResolvedModal(false); setSelectedIdsForPending([]); }}
                canceltext={"Cancel"} successtext={"Yes"} successcall={(e) => ResolvedTicketCall(e)} btntype={'SaveBtn'} />

        </Fragment >
    )
}
